<template>
  <section>
    <div class="fixed z-10 inset-0 overflow-y-auto" v-if="true">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>

        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              type="button"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500"
            >
              <span class="sr-only"></span>
            </button>
          </div>
          <div class="flex flex-col">
            <div class="justify-end flex">
              <button @click="$emit('sessionDeleteModalEvent', false)">
                <X />
              </button>
            </div>
            <div class="flex justify-center items-center py-11">
              <svg xmlns="http://www.w3.org/2000/svg" width="72.333" height="93" viewBox="0 0 72.333 93">
                <path data-name="Icon material-delete-forever" d="M12.667 87.167A10.364 10.364 0 0 0 23 97.5h41.333a10.364 10.364 0 0 0 10.334-10.333v-62h-62zm12.71-36.787 7.285-7.28 11 10.953L54.62 43.1l7.28 7.28-10.948 10.953L61.9 72.287l-7.28 7.285-10.953-10.954-10.954 10.954-7.285-7.285 10.954-10.954zM61.75 9.667 56.583 4.5H30.75l-5.167 5.167H7.5V20h72.333V9.667z" transform="translate(-7.5 -4.5)" style="fill:#707070"/>
              </svg>
            </div>
            <div class="sm:ml-8 ml-6 sm:mt-1 mt-8 text-lg" style="text-align-last: center">
              {{ message }}
            </div>
          </div>
          <div class="flex mt-6 justify-center font-semibold">
            <!-- button 1 -->
            <div
              @click="$emit('sessionDeleteModalEvent', false)"
              class="ring-1 ring-gray-600 py-3 px-3 text-gray-600 rounded-lg cursor-pointer hover:shadow-lg"
            >
              {{ cancel==='' ? 'Cancel' : cancel}}
            </div>
            <!-- button 2 -->
            <div
              @click="$emit('sessionDeleteModalEvent', true)"
              class="text-white bg-red-600 py-3 px-6 ml-4 rounded-lg tracking-widest cursor-pointer hover:shadow-lg"
            >
              {{ deleteClass==='' ? 'Delete' : 'Delete Class'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { X } from "@/components/icons";

export default {
  name: "ConfirmationAlert",
  components: {
    X
  },
  props: {
    message: {
      type: String,
      default: "",
    },
    cancel: {
      type: String,
      default: "",
    },
    deleteClass: {
      type: String,
      default: "",
    },
  },
};
</script>